import { Metrics } from '../metrics/Metrics';
export class InMemoryCache {
  constructor(id, fetch, serializeKey) {
    this.cache = new Map();
    this.subscribers = new Map();
    this.cache = new Map();
    this.id = id;
    this.fetch = fetch;
    this.serializeKey = serializeKey;
  }
  notify(cacheKey) {
    const subscribers = this.subscribers.get(cacheKey);
    if (subscribers) {
      subscribers.forEach(callback => callback());
    }
  }
  subscribe(key, callback) {
    const cacheKey = this.serializeKey(key);
    let subscribers = this.subscribers.get(cacheKey);
    if (!subscribers) {
      subscribers = new Set();
      this.subscribers.set(cacheKey, subscribers);
    }
    subscribers.add(callback);
    return () => {
      subscribers = this.subscribers.get(cacheKey);
      if (!subscribers) {
        return;
      }
      subscribers.delete(callback);
      if (subscribers.size === 0) {
        this.subscribers.delete(cacheKey);
      }
    };
  }
  getEntryId(cacheKey) {
    const existing = this.cache.get(cacheKey);
    return existing ? existing.id : 0;
  }
  setEntry(cacheKey, entry) {
    this.cache.set(cacheKey, entry);
    this.notify(cacheKey);
  }
  read(key) {
    const cacheKey = this.serializeKey(key);
    return this.cache.get(cacheKey);
  }
  get(key, httpClient, rpcClient, refetch = false) {
    const cacheKey = this.serializeKey(key);
    const existing = this.cache.get(cacheKey);
    if (existing !== undefined && !refetch) {
      Metrics.counter('inmemorycache-hit', {
        id: this.id
      }).increment();
      const {
        status
      } = existing.result;
      if (status === 'success') {
        return Promise.resolve(existing.result.value);
      } else if (status === 'error') {
        return Promise.reject(existing.result.error);
      } else if (status === 'pending') {
        return existing.result.promise;
      }
    }
    Metrics.counter('inmemorycache-miss', {
      id: this.id
    }).increment();
    const promise = this.fetch(key, httpClient, rpcClient);
    const nextId = this.getEntryId(cacheKey) + 1;
    this.setEntry(cacheKey, {
      result: {
        status: 'pending',
        promise
      },
      id: nextId
    });
    return promise.then(value => {
      const currentEntryId = this.getEntryId(cacheKey);
      if (currentEntryId === nextId) {
        this.setEntry(cacheKey, {
          result: {
            status: 'success',
            value
          },
          id: nextId
        });
      }
      return value;
    }, error => {
      const currentEntry = this.cache.get(cacheKey);
      if ((currentEntry === null || currentEntry === void 0 ? void 0 : currentEntry.id) === nextId) {
        this.setEntry(cacheKey, {
          result: {
            status: 'error',
            error
          },
          id: nextId
        });
      }
      throw error;
    });
  }
  delete(key) {
    const cacheKey = this.serializeKey(key);
    this.notify(cacheKey);
    return this.cache.delete(cacheKey);
  }
  clear() {
    const keys = Array.from(this.cache.keys());
    this.cache.clear();
    keys.forEach(key => {
      this.notify(key);
    });
  }
  size() {
    return this.cache.size;
  }
  has(key) {
    return this.cache.has(this.serializeKey(key));
  }
  set(key, value) {
    const cacheKey = this.serializeKey(key);
    const nextId = this.getEntryId(cacheKey) + 1;
    this.setEntry(cacheKey, {
      id: nextId,
      result: {
        status: 'success',
        value
      }
    });
  }
}